import React from 'react';

export const Logo = ({ className = "w-12 h-12" }) => {
  return (
    <svg 
      viewBox="0 0 100 100" 
      className={className}
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Outer Circle */}
      <circle 
        cx="50" 
        cy="50" 
        r="48" 
        stroke="currentColor" 
        strokeWidth="2"
        className="text-blue-400"
      />
      
      {/* Mountain Shape - Creative geometric design */}
      <path 
        d="M 50 20 L 70 55 L 60 55 L 60 65 L 40 65 L 40 55 L 30 55 Z" 
        fill="currentColor"
        className="text-blue-500"
      />
      
      {/* Mountain Peak Detail */}
      <path 
        d="M 50 20 L 60 40 L 50 35 L 40 40 Z" 
        fill="currentColor"
        className="text-blue-300"
      />
      
      {/* Base Line */}
      <line 
        x1="25" 
        y1="65" 
        x2="75" 
        y2="65" 
        stroke="currentColor" 
        strokeWidth="2"
        className="text-blue-400"
      />
      
      {/* Accent dots for tech feel */}
      <circle cx="50" cy="50" r="2" fill="currentColor" className="text-blue-300" />
      <circle cx="35" cy="60" r="1.5" fill="currentColor" className="text-blue-300" />
      <circle cx="65" cy="60" r="1.5" fill="currentColor" className="text-blue-300" />
    </svg>
  );
};

export const LogoWithText = ({ className = "" }) => {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <Logo className="w-10 h-10" />
      <span className="text-xl font-bold tracking-tight">
        Valtellina <span className="text-blue-400">Software</span>
      </span>
    </div>
  );
};
